import Highcharts from 'highcharts';

export const barChartoptions = {
  chart: {
    type: 'column',
    events: {
      render: function () {
        //console.log('render');
      },
      redraw: function () {
        //console.log('redraw');
      },
    },
    backgroundColor: '#eef0f3',
    spacing: [10, 0, 0, 0],
  },
  credits: {
    mapText: '',
    mapTextFull: '',
    text: '',
  },
  exporting: {
    chartOptions: {
      title: {
        style: {
          'font-size': '16px',
          'font-weight': 'bold',
          'font-family': 'Arimo, Arial, sans-serif',
        },
      },
      chart: {
        spacing: [10, 10, 10, 10],
        marginBottom: 50,
      },
      credits: {
        mapText: '',
        mapTextFull: '',
        text: 'IWP – Swiss Inequality Database',
      },
    },
    buttons: {
      contextButton: {
        enabled: false,
      },
    },
  },
  title: {
    text: '',
  },
  yAxis: [
    {
      title: {
        text: 'Umverteilung (in CHF pro Kopf)',
        style: {
          color: '#21689d',
        },
      },
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0);
        },
      },
      // The baseline (value = 0) should appear stronger. To achieve the desired effect, the baseline is overlayed with a darker plotline (IWP-251)
      plotLines: [
        {
          value: 0,
          color: '#C0C0C0',
          zIndex: 1,
        },
      ],
    },
  ],
  xAxis: [
    {
      type: 'category',
      labels: {
        formatter: function () {
          var color = '#21689d';
          return `<span style="color:${color}">${this.value}</span>`;
        },
      },
    },
  ],
  colorAxis: {
    minColor: '#95cae7',
    maxColor: '#033e72',
    showInLegend: false,
  },
  series: [],
  plotOptions: {
    series: {
      borderWidth: 0,
    },
  },
  tooltip: {
    backgroundColor: null,
    borderWidth: 0,
    shared: false,
    useHTML: true,
    footerFormat: '</div>',
    shadow: false,
  },
  loading: {
    hideDuration: 100,
    showDuration: 500,
  },
};
